module.exports = __webpack_public_path__ + "media/bootstrap-icons/smartwatch-fc08db88.svg";